import useUser from 'Utilities/hooks/useUser';

import { getUserAttributesPayload } from './optimizely';

export const useOptimizelyUserAttributes = (): Record<string, Nullable<string>> => {
	const { dealerId, id } = useUser();

	return getUserAttributesPayload({ dealerContactId: id, dealershipId: dealerId });
};
